document.addEventListener('DOMContentLoaded', function() {
  console.log('Collection template JS loaded');
  
  // Show skeleton loading initially
  showSkeletonLoading();
  
  // Hide skeleton after content is loaded
  window.addEventListener('load', () => {
    setTimeout(() => {
      hideSkeletonLoading();
    }, 500);
  });
  
  // Initialize Lucide icons
  if (typeof lucide !== 'undefined') {
    lucide.createIcons();
  } else {
    console.warn('Lucide icons library not loaded');
  }

  // Elements
  const compareButtons = document.querySelectorAll('.compare-button');
  const comparisonToast = document.getElementById('comparison-toast');
  const toastText = document.getElementById('toast-text');
  const compareProductsBtn = document.getElementById('compare-products-btn');
  const clearSelectionsBtn = document.getElementById('clear-selections-btn');
  const comparisonModal = document.getElementById('product-comparison-modal');
  const closeModalBtn = document.getElementById('close-comparison-modal');
  const comparisonSectionsContainer = document.getElementById('comparison-sections-container');
  const tabButtons = document.querySelectorAll('.tab-button');
  const sortSelect = document.getElementById('sort-select');
  const productsGrid = document.querySelector('.collection-products-grid');
  
  // State
  let selectedProducts = [];
  let activeTab = 'overview';
  const MAX_COMPARISON_PRODUCTS = 3; // Fixed at 3 products for all devices
  let allProducts = []; // Store original product data for sorting

  // Verify critical elements exist
  if (!comparisonModal) console.error('Comparison modal element not found');
  if (!closeModalBtn) console.error('Close modal button not found');
  if (!compareProductsBtn) console.error('Compare products button not found');
  if (!comparisonSectionsContainer) console.error('Comparison sections container not found');

  // Initialize
  try {
    // Check if comparison should be disabled for this collection
    const collectionTemplate = document.querySelector('.collection-template');
    const comparisonDisabled = collectionTemplate && collectionTemplate.classList.contains('hide-compare');
    
    if (!comparisonDisabled) {
      initializeComparisonUI();
    } else {
      console.log('Comparison functionality disabled for this collection');
    }
    
    initializeSorting();
    handleLastRowBorders();
    
    // Add resize listener to recalculate borders on window resize
    window.addEventListener('resize', debounce(handleLastRowBorders, 250));
  } catch (error) {
    console.error('Error during initialization:', error);
  }

  /**
   * Initialize sorting functionality
   */
  function initializeSorting() {
    if (!sortSelect || !productsGrid) {
      console.warn('Sort elements not found');
      return;
    }

    console.log('Initializing sorting functionality');

    // Store original product data
    storeOriginalProductData();
    
    // Add event listener to sort select
    sortSelect.addEventListener('change', function() {
      const sortValue = this.value;
      console.log('Sort changed to:', sortValue);
      
      // Add loading state
      sortSelect.disabled = true;
      productsGrid.style.opacity = '0.6';
      
      // Sort products with a small delay for visual feedback
      setTimeout(() => {
        sortProducts(sortValue);
        
        // Remove loading state
        sortSelect.disabled = false;
        productsGrid.style.opacity = '1';
        
        // Update URL parameter for sort
        updateSortURL(sortValue);
      }, 100);
    });

    // Check URL for existing sort parameter
    const urlParams = new URLSearchParams(window.location.search);
    const currentSort = urlParams.get('sort_by');
    if (currentSort && currentSort !== 'manual') {
      sortSelect.value = currentSort;
      sortProducts(currentSort);
    }
    
    console.log('Sorting initialization complete');
  }
  
  /**
   * Update URL with sort parameter
   */
  function updateSortURL(sortValue) {
    try {
      const url = new URL(window.location);
      if (sortValue === 'manual') {
        url.searchParams.delete('sort_by');
      } else {
        url.searchParams.set('sort_by', sortValue);
      }
      window.history.replaceState({}, '', url);
    } catch (error) {
      console.warn('Could not update URL:', error);
    }
  }

  /**
   * Store original product data for sorting
   */
  function storeOriginalProductData() {
    const productCards = document.querySelectorAll('.product-card');
    allProducts = [];
    
    productCards.forEach((card, index) => {
      const titleElement = card.querySelector('.product-card-title a');
      const priceElement = card.querySelector('.product-card-price');
      const brandElement = card.querySelector('.product-brand');
      
      // Extract data attributes for sorting
      const compareButton = card.querySelector('.compare-button');
      let createdDate = new Date(Date.now() - (index * 24 * 60 * 60 * 1000)); // Simulate creation dates
      let bestSelling = Math.floor(Math.random() * 100) + (100 - index); // Simulate best selling with original order preference
      
      // Try to get additional data from metafields
      if (compareButton) {
        try {
          const metafields = JSON.parse(compareButton.getAttribute('data-metafields'));
          // You could add created_at or sales data to metafields if available
          if (metafields.created_at) {
            createdDate = new Date(metafields.created_at);
          }
          if (metafields.sales_count) {
            bestSelling = parseInt(metafields.sales_count) || bestSelling;
          }
        } catch (error) {
          console.warn('Error parsing metafields for sorting:', error);
        }
      }
      
      allProducts.push({
        element: card,
        title: titleElement ? titleElement.textContent.trim() : '',
        price: priceElement ? parseFloat(priceElement.textContent.replace(/[^0-9.]/g, '')) || 0 : 0,
        brand: brandElement ? brandElement.textContent.trim() : '',
        originalIndex: index,
        createdAt: createdDate,
        bestSelling: bestSelling
      });
    });
    
    console.log('Stored product data for sorting:', allProducts.length, 'products');
  }

  /**
   * Sort products based on selected criteria
   */
  function sortProducts(sortType) {
    if (!allProducts.length) {
      console.warn('No products to sort');
      return;
    }

    console.log(`Sorting products by: ${sortType}`);
    
    // Show skeleton loading during sort
    showSkeletonLoading();
    
    // Add a small delay to show the loading state
    setTimeout(() => {
      let sortedProducts = [...allProducts];

    switch (sortType) {
      case 'price-asc':
        sortedProducts.sort((a, b) => {
          if (a.price === b.price) return a.originalIndex - b.originalIndex;
          return a.price - b.price;
        });
        break;
      case 'price-desc':
        sortedProducts.sort((a, b) => {
          if (a.price === b.price) return a.originalIndex - b.originalIndex;
          return b.price - a.price;
        });
        break;
      case 'title-asc':
        sortedProducts.sort((a, b) => {
          const comparison = a.title.localeCompare(b.title, undefined, { numeric: true, sensitivity: 'base' });
          return comparison !== 0 ? comparison : a.originalIndex - b.originalIndex;
        });
        break;
      case 'title-desc':
        sortedProducts.sort((a, b) => {
          const comparison = b.title.localeCompare(a.title, undefined, { numeric: true, sensitivity: 'base' });
          return comparison !== 0 ? comparison : a.originalIndex - b.originalIndex;
        });
        break;
      case 'created-desc':
        sortedProducts.sort((a, b) => {
          const timeDiff = b.createdAt.getTime() - a.createdAt.getTime();
          return timeDiff !== 0 ? timeDiff : a.originalIndex - b.originalIndex;
        });
        break;
      case 'created-asc':
        sortedProducts.sort((a, b) => {
          const timeDiff = a.createdAt.getTime() - b.createdAt.getTime();
          return timeDiff !== 0 ? timeDiff : a.originalIndex - b.originalIndex;
        });
        break;
      case 'best-selling':
        sortedProducts.sort((a, b) => {
          if (a.bestSelling === b.bestSelling) return a.originalIndex - b.originalIndex;
          return b.bestSelling - a.bestSelling;
        });
        break;
      case 'manual':
      default:
        sortedProducts.sort((a, b) => a.originalIndex - b.originalIndex);
        break;
    }

    console.log(`Sorted ${sortedProducts.length} products`);
    
    // Reorder DOM elements
    reorderProductElements(sortedProducts);
    
    // Hide skeleton and show products after sorting
    setTimeout(() => {
      hideSkeletonLoading();
      handleLastRowBorders();
      // Reinitialize comparison functionality for reordered elements
      reinitializeComparisonButtons();
    }, 100);
    
    }, 300); // End of setTimeout for skeleton loading
  }

  /**
   * Reorder product elements in the DOM
   */
  function reorderProductElements(sortedProducts) {
    if (!productsGrid) {
      console.error('Products grid not found');
      return;
    }

    // Store any non-product elements (like empty collection message)
    const nonProductElements = Array.from(productsGrid.children).filter(
      child => !child.classList.contains('product-card')
    );

    // Create document fragment for efficient DOM manipulation
    const fragment = document.createDocumentFragment();
    
    // Add sorted product elements
    sortedProducts.forEach(product => {
      if (product.element && product.element.parentNode) {
        fragment.appendChild(product.element);
      }
    });
    
    // Clear grid and append sorted products
    productsGrid.innerHTML = '';
    productsGrid.appendChild(fragment);
    
    // Re-add any non-product elements at the end
    nonProductElements.forEach(element => {
      productsGrid.appendChild(element);
    });
    
    console.log('Reordered product elements in DOM');
  }

  /**
   * Reinitialize comparison button event listeners after sorting
   */
  function reinitializeComparisonButtons() {
    // Remove old event listeners by cloning and replacing elements
    const newCompareButtons = document.querySelectorAll('.compare-button');
    
    newCompareButtons.forEach(button => {
      // Clone button to remove old event listeners
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
      
      // Check if this product was previously selected
      const productHandle = newButton.getAttribute('data-product-handle');
      if (selectedProducts.includes(productHandle)) {
        newButton.classList.add('selected');
        newButton.textContent = 'Remove';
      }
      
      // Add click event listener
      newButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Check if comparison is disabled for this collection
        const collectionTemplate = document.querySelector('.collection-template');
        if (collectionTemplate && collectionTemplate.classList.contains('hide-compare')) {
          console.log('Comparison disabled for this collection');
          return; // Exit early if comparison is disabled
        }
        
        const productId = this.getAttribute('data-product-id');
        const productHandle = this.getAttribute('data-product-handle');
        
        console.log('Compare button clicked for product:', productHandle);
        
        if (selectedProducts.includes(productHandle)) {
          // Remove from comparison
          selectedProducts = selectedProducts.filter(handle => handle !== productHandle);
          this.classList.remove('selected');
          this.textContent = 'Compare';
        } else {
          // Add to comparison (max 2 products)
          if (selectedProducts.length >= MAX_COMPARISON_PRODUCTS) {
            // Remove oldest selection if at max
            const oldestHandle = selectedProducts.shift();
            const oldestButton = document.querySelector(`.compare-button[data-product-handle="${oldestHandle}"]`);
            if (oldestButton) {
              oldestButton.classList.remove('selected');
              oldestButton.textContent = 'Compare';
            }
          }
          
          selectedProducts.push(productHandle);
          this.classList.add('selected');
          this.textContent = 'Remove';
        }
        
        updateComparisonUI();
      });
    });
    
    console.log('Reinitialized comparison buttons, selected products:', selectedProducts);
  }

  /**
   * Debounce function to limit how often a function can be called
   */
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  // Add event listeners to compare buttons (initial load)
  compareButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Check if comparison is disabled for this collection
      const collectionTemplate = document.querySelector('.collection-template');
      if (collectionTemplate && collectionTemplate.classList.contains('hide-compare')) {
        console.log('Comparison disabled for this collection');
        return; // Exit early if comparison is disabled
      }
      
      const productHandle = this.getAttribute('data-product-handle');
      console.log('Compare button clicked, handle:', productHandle);
      
      // If product is already selected, deselect it
      if (this.classList.contains('selected')) {
        this.classList.remove('selected');
        selectedProducts = selectedProducts.filter(handle => handle !== productHandle);
      } 
      // If we haven't reached the max number of products, select it
      else if (selectedProducts.length < MAX_COMPARISON_PRODUCTS) {
        this.classList.add('selected');
        selectedProducts.push(productHandle);
      }
      
      updateComparisonUI();
    });
  });

  // Compare products button click
  if (compareProductsBtn) {
    compareProductsBtn.addEventListener('click', function() {
      if (selectedProducts.length >= 2 && selectedProducts.length <= MAX_COMPARISON_PRODUCTS) {
        console.log('Opening comparison modal with', selectedProducts.length, 'products');
        showComparisonModal();
        populateComparisonContent();
      }
    });
  }

  // Clear selections button click
  if (clearSelectionsBtn) {
    clearSelectionsBtn.addEventListener('click', function() {
      console.log('Clear selections clicked');
      resetComparison();
    });
  }
  
  // Close modal button click
  if (closeModalBtn) {
    closeModalBtn.addEventListener('click', function() {
      console.log('Close modal button clicked');
      hideComparisonModal();
    });
  }
  
  // Close modal when clicking outside content
  if (comparisonModal) {
    comparisonModal.addEventListener('click', function(e) {
      if (e.target === comparisonModal) {
        console.log('Clicked outside modal content');
        hideComparisonModal();
      }
    });
  }
  
  // Close modal on Escape key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && comparisonModal && comparisonModal.classList.contains('visible')) {
      hideComparisonModal();
    }
  });
  
  /**
   * Initialize the comparison UI elements
   */
  function initializeComparisonUI() {
    console.log('Initializing comparison UI');
    
    // Check if comparison should be disabled for this collection
    const collectionTemplate = document.querySelector('.collection-template');
    if (collectionTemplate && collectionTemplate.classList.contains('hide-compare')) {
      console.log('Comparison disabled for this collection');
      return; // Exit early if comparison is disabled
    }
    
    // Ensure modal is hidden
    if (comparisonModal) {
      comparisonModal.classList.remove('visible');
      comparisonModal.setAttribute('data-modal-state', 'hidden');
    }
    // Hide toast initially
    if (comparisonToast) {
      comparisonToast.classList.remove('visible');
      toastText.style.display = 'block';
      compareProductsBtn.style.display = 'none';
    }
  }
  
  /**
   * Update the comparison UI based on selected products
   */
  function updateComparisonUI() {
    console.log('Updating comparison UI, selected products:', selectedProducts);
    // Hide toast initially
    comparisonToast.classList.remove('visible');
    
    // Show appropriate UI based on number of selected products
    if (selectedProducts.length === 1) {
      // Show toast asking to select more products
      toastText.textContent = 'Select 2 more products to compare.';
      comparisonToast.classList.add('visible');
      compareProductsBtn.style.display = 'none';
      clearSelectionsBtn.style.display = 'inline-block';
    } else if (selectedProducts.length === 2) {
      // Show intermediate state - can compare current selection or select one more
      toastText.textContent = 'Compare now or select 1 more product.';
      comparisonToast.classList.add('visible');
      compareProductsBtn.style.display = 'inline-block';
      clearSelectionsBtn.style.display = 'inline-block';
    } else if (selectedProducts.length === 3) {
      // Show compare button when we have 3 products
      toastText.textContent = 'Ready to compare 3 products!';
      comparisonToast.classList.add('visible');
      compareProductsBtn.style.display = 'inline-block';
      clearSelectionsBtn.style.display = 'inline-block';
    } else {
      // No products selected or more than max
      comparisonToast.classList.remove('visible');
      compareProductsBtn.style.display = 'none';
      clearSelectionsBtn.style.display = 'none';
    }
  }  /**
   * Show the comparison modal
   */
  function showComparisonModal() {
    if (comparisonModal) {
      comparisonModal.classList.add('visible');
      comparisonModal.setAttribute('data-modal-state', 'visible');
      document.body.style.overflow = 'hidden'; // Prevent scrolling when modal is open
      
      // Re-initialize Lucide icons for the modal content
      if (typeof lucide !== 'undefined') {
        setTimeout(() => lucide.createIcons(), 100);
      }

      // Animate progress bars after modal opens
      setTimeout(() => {
        animateProgressBars(comparisonModal);
      }, 300);
    }
  }
  
  /**
   * Hide the comparison modal
   */
  function hideComparisonModal() {
    if (comparisonModal) {
      comparisonModal.classList.remove('visible');
      comparisonModal.setAttribute('data-modal-state', 'hidden');
      document.body.style.overflow = ''; // Restore scrolling
      
      // Reset progress bars
      resetProgressBars(comparisonModal);
    }
  }
  
  /**
   * Get product data from button's data-metafields
   */
  function getProductData(handle) {
    const button = document.querySelector(`.compare-button[data-product-handle="${handle}"]`);
    if (!button) {
      console.error('No button found for handle:', handle);
      return null;
    }
    
    try {
      const metafields = JSON.parse(button.getAttribute('data-metafields'));
      
      // Get the product URL from the product card
      const productCard = button.closest('.product-card');
      let productUrl = '#';
      if (productCard) {
        const productLink = productCard.querySelector('.product-card-title a, .shop-now-btn');
        if (productLink) {
          productUrl = productLink.href;
        }
      }
      
      // Get product image from the card
      let productImage = 'https://via.placeholder.com/200x200?text=Safe';
      if (productCard) {
        const imgElement = productCard.querySelector('.product-card-image');
        if (imgElement && imgElement.src) {
          productImage = imgElement.src;
        }
      }
      
      return {
        ...metafields,
        handle: handle,
        url: productUrl,
        image: productImage
      };
    } catch (error) {
      console.error('Error parsing metafields for handle:', handle, error);
      return null;
    }
  }
  
  /**
   * Normalize boolean-like fields to 'Yes' or 'No'
   */
  function normalizeBooleanField(value) {
    if (value === null || value === undefined || value === 'N/A') return 'No';
    const normalized = String(value).toLowerCase();
    return ['yes', 'true', '1', 'y'].includes(normalized) ? 'Yes' : 'No';
  }
  
  /**
   * Populate all comparison content
   */
  function populateComparisonContent() {
    // Get product data
    const productData = selectedProducts.map(handle => getProductData(handle));

    console.log(productData);
    
    // Clear existing product cards
    const productsGrid = document.querySelector('.modal-body .products-grid');
    if (productsGrid) {
      productsGrid.innerHTML = '';
      
      // Set the product count data attribute for CSS styling
      productsGrid.setAttribute('data-product-count', productData.length);
      
      // Create product cards dynamically based on number of selected products
      productData.forEach((product, index) => {
        if (product) {
          const cardDiv = document.createElement('div');
          cardDiv.className = 'product-card';
          cardDiv.id = `modal-product-${index + 1}`;
          productsGrid.appendChild(cardDiv);
          
          populateModalProductCard(`modal-product-${index + 1}`, product);
        }
      });
    }
    
    // Initialize Lucide icons in the newly created content
    if (typeof lucide !== 'undefined') {
      setTimeout(() => lucide.createIcons(), 100);
    }
  }

  /**
   * Populate a modal product card with product data
   */
  function populateModalProductCard(cardId, product) {
    const card = document.getElementById(cardId);
    if (!card || !product) return;

    // Generate star rating
    const rating = generateRandomRating();
    const isOnSale = product.compare_at_price && parseFloat(product.compare_at_price) > parseFloat(product.price);
    
    // Calculate scores for metrics (now return percentages directly)
    const securityScore = getSecurityScore(product);
    const fireScore = getFireScore(product);
    const capacityScore = getCapacityScore(product);

    // Metric ratings are already percentages (0-100)
    const securityRating = securityScore;
    const fireRating = fireScore;
    const capacityRating = capacityScore;

    // Get metric grades and colors
    const securityGrade = getMetricGrade(securityRating);
    const fireGrade = getMetricGrade(fireRating);
    const capacityGrade = getMetricGrade(capacityRating);

    // Build features list
    const features = [];
    if (product.gun_count && product.gun_count !== '0') {
      features.push(`Holds up to ${product.gun_count} guns`);
    }
    if (product.made_in_usa === 'Yes') {
      features.push('Made in USA');
    }
    if (product.security_level && product.security_level !== 'N/A') {
      features.push(product.security_level);
    }
    if (product.fire_protection && product.fire_protection !== 'N/A') {
      features.push(product.fire_protection);
    }

    // Only show a performance metric that has data: a missing value scores 0 and would otherwise render an empty bar
    // labelled "Good" (e.g. home safes have no gun capacity). Hide the whole section when none has data.
    const metricRow = (icon, label, grade, rating) => `
        <div class="metric">
          <div class="metric-header">
            <span class="metric-label">
              <i data-lucide="${icon}" class="metric-icon"></i>
              ${label}
            </span>
            <span class="metric-rating">${grade.label}</span>
          </div>
          <div class="progress-bar-container">
            <div class="progress-bar ${grade.class}" data-width="${rating}"></div>
          </div>
        </div>`;
    const metricRows = [
      securityRating > 0 ? metricRow('shield', 'Security', securityGrade, securityRating) : '',
      fireRating > 0 ? metricRow('flame', 'Fire Protection', fireGrade, fireRating) : '',
      capacityRating > 0 ? metricRow('package', 'Capacity', capacityGrade, capacityRating) : ''
    ].filter(Boolean);
    const metricsHTML = metricRows.length
      ? `<div class="metrics-section">
        <h4 class="metrics-title">Performance Metrics</h4>
        ${metricRows.join('')}
      </div>`
      : '';

    card.innerHTML = `
      <div class="product-image-container">
        <img src="${product.image || 'https://via.placeholder.com/400x300?text=Safe'}" 
             alt="${product.title}" class="product-image">
        ${isOnSale ? '<div class="discount-badge">ON SALE</div>' : ''}
      </div>

      <h3 class="product-title">${getTitlePart(product.title)}</h3>
      
      <div class="price-container">
        <span class="current-price">$${product.price}</span>
        ${isOnSale ? `<span class="original-price">$${product.compare_at_price}</span>` : ''}
      </div>
      <p class="supporting-note">${product.security_level || 'Professional security protection'}</p>

      ${metricsHTML}

      <div class="features-section">
        <h4 class="features-title">Key Features</h4>
        <ul class="features-list">
          ${features.map(feature => `
            <li class="feature-item">
              <i data-lucide="check" class="check-icon"></i>
              ${feature}
            </li>
          `).join('')}
        </ul>
      </div>

      <a href="${product.url || '#'}" class="cta-button">
        Choose ${getTitlePart(product.title)}
      </a>
    `;

    // Animate progress bars after a short delay
    setTimeout(() => {
      animateProgressBars(card);
    }, 300);
  }
  
  /**
   * Update product headers with image, title, and price
   */
  function updateProductHeaders(products) {
    products.forEach((product, index) => {
      if (!product) return;
      
      const headerIndex = index + 1; // 1-based indexing for IDs
      const headerEl = document.getElementById(`product-header-${headerIndex}`);
      
      if (headerEl) {
        // Set image
        const imageContainer = headerEl.querySelector('.product-image-container');
        if (imageContainer) {
          imageContainer.innerHTML = `<img src="${product.image || 'https://via.placeholder.com/150x150?text=Safe'}" alt="${product.title}">`;
        }
        
        // Set title - cut off after second |
        const nameEl = headerEl.querySelector('.product-name');
        if (nameEl) {
          // Split by | and only use first two parts
          const titleParts = product.title.split('|');
          let displayTitle = product.title;
          
          if (titleParts.length >= 2) {
            displayTitle = titleParts.slice(0, 2).join('|');
          }
          
          nameEl.textContent = displayTitle.trim();
        }
        
        // Set price
        const priceEl = headerEl.querySelector('.product-price');
        if (priceEl && product.price) {
          let formattedPrice = product.price;
          if (!isNaN(parseFloat(product.price))) {
            formattedPrice = '$' + product.price;
          }
          priceEl.textContent = formattedPrice;
        }
      }
    });
  }
  
  /**
   * Create overview section
   */
  function createOverviewSection(products) {
    const section = document.createElement('div');
    section.className = 'comparison-section';
    section.setAttribute('data-section', 'overview');
    
    section.innerHTML = `
      <div class="section-title">
        <i data-lucide="clipboard-list" class="section-title-icon"></i> Overview
      </div>
    `;
    
    // Price Comparison
    section.appendChild(createFeatureRow({
      icon: 'banknote',
      label: 'Price',
      values: products.map(p => {
        if (!p || !p.price) return 'N/A';
        return `
          <div class="price-tag">$${p.price}</div>
          <span class="price-label">Retail Price</span>
        `;
      })
    }));
    
    // Brand
    section.appendChild(createFeatureRow({
      icon: 'building',
      label: 'Brand',
      values: products.map(p => p && p.brand ? p.brand : 'N/A')
    }));
    
    // Model
    section.appendChild(createFeatureRow({
      icon: 'box',
      label: 'Model',
      values: products.map(p => p && p.model ? p.model : 'N/A')
    }));
    
    // Made in USA
    section.appendChild(createFeatureRow({
      icon: 'flag',
      label: 'Made in USA',
      values: products.map(p => {
        if (!p) return 'N/A';
        const isUSA = p.made_in_usa === 'Yes';
        return `
          <div class="usa-badge">
            <span class="indicator ${isUSA ? 'yes' : 'no'}">
              <i data-lucide="${isUSA ? 'check' : 'x'}" class="indicator-icon"></i>
            </span>
            <span>${isUSA ? 'Yes' : 'No'}</span>
          </div>
        `;
      })
    }));
    
    comparisonSectionsContainer.appendChild(section);
  }
  
  /**
   * Create security section with shield icons for security level
   */
  function createSecuritySection(products) {
    const section = document.createElement('div');
    section.className = 'comparison-section';
    section.setAttribute('data-section', 'security');
    
    section.innerHTML = `
      <div class="section-title">
        <i data-lucide="shield" class="section-title-icon"></i> Security Features
      </div>
    `;
    
    // Security Level with shield icons - Match compare section logic
    section.appendChild(createFeatureRow({
      icon: 'shield',
      label: 'Security Level',
      values: products.map(p => {
        if (!p) return 'N/A';
        
        // Extract security level from security_level field
        const securityLevel = p.security_level || 'N/A';
        
        // Extract level number (1-10) from the security level text
        let level = 0;
        const levelMatch = securityLevel.match(/Level\s+(\d+)/i);
        if (levelMatch && levelMatch[1]) {
          level = parseInt(levelMatch[1]);
        } else {
          // Try to extract just a number
          const numberMatch = securityLevel.match(/(\d+)/);
          if (numberMatch && numberMatch[1]) {
            level = parseInt(numberMatch[1]);
            // Cap at 10 for display
            if (level > 10) level = 10;
          }
        }
        
        // Create shield icons based on level (only show the actual level, not up to 10)
        let shieldHtml = '';
        for (let i = 0; i < level && i < 5; i++) {
          shieldHtml += `<i data-lucide="shield" class="rating-icon security-icon"></i>`;
        }
        
        return `
          <div class="icon-rating">
            <div class="icon-row">${shieldHtml}</div>
            <div class="rating-description">${securityLevel}</div>
          </div>
        `;
      })
    }));
    
    // Burglary Rating 
    section.appendChild(createFeatureRow({
      icon: 'shield-alert',
      label: 'Burglary Rating',
      values: products.map(p => {
        if (!p || !p.burglary_rating || p.burglary_rating === 'N/A') return 'N/A';
        return `<div class="rating-description">${p.burglary_rating}</div>`;
      })
    }));
    
    comparisonSectionsContainer.appendChild(section);
  }
  
  /**
   * Create fire protection section with flame icons
   */
  function createFireSection(products) {
    const section = document.createElement('div');
    section.className = 'comparison-section';
    section.setAttribute('data-section', 'fire');
    
    section.innerHTML = `
      <div class="section-title">
        <i data-lucide="flame" class="section-title-icon"></i> Fire Protection
      </div>
    `;
    
    // Fire Protection with flame icons - Match compare section logic
    section.appendChild(createFeatureRow({
      icon: 'flame',
      label: 'Fire Protection',
      values: products.map(p => {
        if (!p) return 'N/A';
        
        const fireProtection = p.fire_protection || 'N/A';
        
        // Extract minutes from the fire protection
        const minutesMatch = fireProtection.match(/(\d+)\s*Minute/i);
        let minutes = 0;
        if (minutesMatch && minutesMatch[1]) {
          minutes = parseInt(minutesMatch[1]);
        }
        
        // Determine number of flame icons based on minutes (up to 5)
        let flameCount = 0;
        if (minutes >= 120) flameCount = 5;
        else if (minutes >= 90) flameCount = 4;
        else if (minutes >= 60) flameCount = 3;
        else if (minutes >= 30) flameCount = 2;
        else if (minutes > 0) flameCount = 1;
        
        let flameHtml = '';
        for (let i = 0; i < flameCount; i++) {
          flameHtml += `<i data-lucide="flame" class="rating-icon fire-icon"></i>`;
        }
        
        return `
          <div class="icon-rating">
            <div class="icon-row">${flameHtml}</div>
            <div class="rating-description">${fireProtection}</div>
          </div>
        `;
      })
    }));

    // Fire Rating
    section.appendChild(createFeatureRow({
      icon: 'thermometer',
      label: 'Fire Rating',
      values: products.map(p => {
        if (!p || !p.fire_rating || p.fire_rating === 'N/A') return 'N/A';
        return `<div class="rating-description">${p.fire_rating}</div>`;
      })
    }));
    
    comparisonSectionsContainer.appendChild(section);
  }
  
  /**
   * Create physical specifications section with capacity icons for gun capacity
   */
  function createPhysicalSection(products) {
    const section = document.createElement('div');
    section.className = 'comparison-section';
    section.setAttribute('data-section', 'physical');

    section.innerHTML = `
      <div class="section-title">
        <i data-lucide="ruler" class="section-title-icon"></i> Physical Specifications
      </div>
    `;

    // Gun Count with simple target icons
    section.appendChild(createFeatureRow({
      icon: 'target',
      label: 'Gun Capacity',
      values: products.map(p => {
        if (!p || !p.gun_count || p.gun_count === '0') {
          return 'N/A';
        }

        const gunCount = parseInt(p.gun_count);
        
        // Create capacity icons based on gun count (up to 5 icons)
        let iconCount = 0;
        if (gunCount >= 50) iconCount = 5;
        else if (gunCount >= 40) iconCount = 4;
        else if (gunCount >= 30) iconCount = 3;
        else if (gunCount >= 20) iconCount = 2;
        else if (gunCount > 0) iconCount = 1;
        
        let gunIconHtml = '';
        
        // Add target icons (only show actual count, no empty icons)
        for (let i = 0; i < iconCount; i++) {
          gunIconHtml += `<i data-lucide="target" class="rating-icon gun-icon"></i>`;
        }
        
        return `
          <div class="icon-rating">
            <div class="icon-row">${gunIconHtml}</div>
            <div class="rating-description">Up to ${gunCount} Long Guns</div>
          </div>
        `;
      })
    }));

    // Size Options
    section.appendChild(createFeatureRow({
      icon: 'move-horizontal',
      label: 'Size Options',
      values: products.map(p => {
        if (!p || !p.size_options) {
          return 'N/A';
        }

        try {
          const sizes = Array.isArray(p.size_options) ? p.size_options : JSON.parse(p.size_options);
          if (!sizes || sizes.length === 0) {
            return 'N/A';
          }

          return `
            <div class="size-options">
              ${sizes.map(size => `
                <div class="size-option available">
                  ${size}
                </div>
              `).join('')}
            </div>
          `;
        } catch (error) {
          console.error('Error processing size_options for product:', p?.title || 'Unknown', error);
          return 'N/A';
        }
      })
    }));

    comparisonSectionsContainer.appendChild(section);
  }
  
  /**
   * Create features section
   */
  function createFeaturesSection(products) {
    const section = document.createElement('div');
    section.className = 'comparison-section';
    section.setAttribute('data-section', 'features');
    
    section.innerHTML = `
      <div class="section-title">
        <i data-lucide="sparkles" class="section-title-icon"></i> Additional Features
      </div>
    `;
    
    // Accessory Category
    section.appendChild(createFeatureRow({
      icon: 'package',
      label: 'Accessory Package',
      values: products.map(p => {
        if (!p || !p.accessory_category) return 'N/A';
        
        let badgeClass = 'badge-info';
        if (p.accessory_category.toLowerCase().includes('deluxe')) {
          badgeClass = 'badge-success';
        } else if (p.accessory_category.toLowerCase().includes('standard')) {
          badgeClass = 'badge-warning';
        } else if (p.accessory_category.toLowerCase().includes('basic')) {
          badgeClass = 'badge-danger';
        }
        
        return `<span class="badge ${badgeClass}">${p.accessory_category}</span>`;
      })
    }));
    
    // Door Organizer
    section.appendChild(createFeatureRow({
      icon: 'door-open',
      label: 'Door Organizer',
      values: products.map(p => {
        if (!p) return 'N/A';
        const hasDoorOrganizer = p.door_organizer === 'Yes';
        return `
          <span class="indicator ${hasDoorOrganizer ? 'yes' : 'no'}">
            <i data-lucide="${hasDoorOrganizer ? 'check' : 'x'}" class="indicator-icon"></i>
          </span>
        `;
      })
    }));
    
    // Interior Lighting
    section.appendChild(createFeatureRow({
      icon: 'lightbulb',
      label: 'Interior Lighting',
      values: products.map(p => {
        if (!p) return 'N/A';
        const hasLighting = p.interior_lighting === 'Yes';
        return `
          <span class="indicator ${hasLighting ? 'yes' : 'no'}">
            <i data-lucide="${hasLighting ? 'check' : 'x'}" class="indicator-icon"></i>
          </span>
        `;
      })
    }));
    
    comparisonSectionsContainer.appendChild(section);
  }
  
  /**
   * Create a feature row with icon, label, and product values
   */
  function createFeatureRow({ icon, label, values }) {
    const row = document.createElement('div');
    row.className = 'feature-row';
    
    // Feature label
    const labelDiv = document.createElement('div');
    labelDiv.className = 'feature-label';
    labelDiv.innerHTML = `
      <i data-lucide="${icon}" class="feature-label-icon"></i>
      ${label}
    `;
    row.appendChild(labelDiv);
    
    // Feature values for each product
    values.forEach(value => {
      const valueDiv = document.createElement('div');
      valueDiv.className = 'feature-value';
      valueDiv.innerHTML = value;
      row.appendChild(valueDiv);
    });
    
    return row;
  }
  
  /**
   * Reset product selections and UI
   */
  function resetComparison() {
    console.log('Resetting comparison');
    // Clear selected products array
    selectedProducts = [];
    
    // Reset all compare buttons
    const allCompareButtons = document.querySelectorAll('.compare-button');
    allCompareButtons.forEach(button => {
      button.classList.remove('selected');
      button.textContent = 'Compare';
    });
    
    // Hide UI elements and update state
    updateComparisonUI();
    hideComparisonModal();
  }

  /**
   * Helper functions for the new modal layout
   */
  function getTitlePart(title) {
    if (!title) return '';
    // Split by | and only use first part like in compare section
    const titleParts = title.split('|');
    return titleParts[0].trim();
  }

  function generateRandomRating() {
    return {
      score: (4.0 + Math.random() * 1).toFixed(1),
      count: Math.floor(50 + Math.random() * 200)
    };
  }

  function getSecurityScore(product) {
    if (!product) return 0;
    
    // Extract security level from security_level field like compare section
    const securityLevel = product.security_level || 'N/A';
    
    // Extract level number (1-10) from the security level text
    let level = 0;
    const levelMatch = securityLevel.match(/Level\s+(\d+)/i);
    if (levelMatch && levelMatch[1]) {
      level = parseInt(levelMatch[1]);
    } else {
      // Try to extract just a number
      const numberMatch = securityLevel.match(/(\d+)/);
      if (numberMatch && numberMatch[1]) {
        level = parseInt(numberMatch[1]);
        // Cap at 10 for display
        if (level > 10) level = 10;
      }
    }
    
    // Convert to percentage (maximum security level is 10)
    const percentage = Math.min((level / 10) * 100, 100);
    return Math.round(percentage);
  }

  function getFireScore(product) {
    const fireTime = extractFireTime(product);
    // Maximum fire protection is 150 minutes
    const percentage = Math.min((fireTime / 150) * 100, 100);
    return Math.round(percentage);
  }

  function getCapacityScore(product) {
    const gunCount = parseInt(product.gun_count) || 0;
    // Maximum gun capacity is 73
    const percentage = Math.min((gunCount / 73) * 100, 100);
    return Math.round(percentage);
  }

  function extractFireTime(product) {
    if (!product) return 0;
    
    // Try the fire_protection field first
    if (product.fire_protection && product.fire_protection !== '') {
      // Try multiple patterns to extract fire time
      let fireTime = 0;
      
      // Method 1: Look for "X Minute" or "X Minutes" pattern (case insensitive)
      let match = product.fire_protection.match(/(\d+)\s*Minutes?/i);
      if (match && match[1]) {
        fireTime = parseInt(match[1]);
      }
      
      // Method 2: If no "Minute" found, try splitting like the Liquid template does
      if (!fireTime) {
        const fireParts = product.fire_protection.split(' Minute');
        if (fireParts.length > 0) {
          // Get the last word before " Minute"
          const beforeMinute = fireParts[0].trim();
          const words = beforeMinute.split(' ');
          const lastWord = words[words.length - 1];
          const timeValue = parseInt(lastWord);
          if (!isNaN(timeValue)) {
            fireTime = timeValue;
          }
        }
      }
      
      if (fireTime > 0) return fireTime;
    }
    
    // Fallback: try the fire_rating_time field
    if (product.fire_rating_time && product.fire_rating_time !== '') {
      const time = parseInt(product.fire_rating_time);
      if (!isNaN(time)) return time;
    }
    
    return 0;
  }

    function generateIconRating(score, iconType) {
    let iconsHTML = '';
    const maxIcons = 10; // Show max 10 icons like compare section
    
    // Convert percentage score to number of icons (0-100% -> 0-10 icons)
    const filledIcons = Math.round((score / 100) * maxIcons);
    
    for (let i = 1; i <= maxIcons; i++) {
      const isFilled = i <= filledIcons;
      let iconClass = `rating-icon ${iconType} ${isFilled ? 'filled' : 'empty'}`;
      let svgContent = '';
      
      switch (iconType) {
        case 'security':
          svgContent = `
            <svg
              class="${iconClass}"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="${isFilled ? '#007ACC' : 'none'}"
              stroke="#007ACC"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/>
            </svg>`;
          break;
        case 'fire':
          svgContent = `
            <svg
              class="${iconClass}"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="${isFilled ? '#DC3545' : 'none'}"
              stroke="#DC3545"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/>
            </svg>`;
          break;
        case 'capacity':
          svgContent = `
            <svg
              class="${iconClass}"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="${isFilled ? '#28A745' : 'none'}"
              stroke="#28A745"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"/>
            </svg>`;
          break;
        default:
          svgContent = `
            <svg
              class="${iconClass}"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="${isFilled ? 'currentColor' : 'none'}"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"/>
            </svg>`;
      }
      
      iconsHTML += svgContent;
    }
    
    return iconsHTML;
  }

  function getSecurityGrade(product) {
    const score = getSecurityScore(product);
    if (score >= 75) return 'BEST';
    if (score >= 50) return 'BETTER';
    return 'GOOD';
  }

  function getFireGrade(product) {
    const score = getFireScore(product);
    if (score >= 75) return 'BEST';
    if (score >= 50) return 'BETTER';
    return 'GOOD';
  }

  function getCapacityGrade(product) {
    const score = getCapacityScore(product);
    if (score >= 75) return 'BEST';
    if (score >= 50) return 'BETTER';
    return 'GOOD';
  }

  /**
   * Show skeleton loading
   */
  function showSkeletonLoading() {
    const collectionTemplate = document.querySelector('.collection-template');
    const skeletonGrid = document.getElementById('skeleton-grid');
    const productsGrid = document.querySelector('.collection-products-grid');
    const collectionHeader = document.querySelector('.collection-header');
    const comparisonContainer = document.querySelector('.product-comparison-container');
    
    if (collectionTemplate) {
      collectionTemplate.classList.add('loading');
    }
    
    if (skeletonGrid) {
      skeletonGrid.style.display = 'grid';
    }
    
    if (productsGrid) {
      productsGrid.style.display = 'none';
    }
    
    if (collectionHeader) {
      collectionHeader.style.display = 'none';
    }
    
    if (comparisonContainer) {
      comparisonContainer.style.display = 'none';
    }
  }

  /**
   * Hide skeleton loading
   */
  function hideSkeletonLoading() {
    const collectionTemplate = document.querySelector('.collection-template');
    const skeletonGrid = document.getElementById('skeleton-grid');
    const productsGrid = document.querySelector('.collection-products-grid');
    const collectionHeader = document.querySelector('.collection-header');
    const comparisonContainer = document.querySelector('.product-comparison-container');
    
    if (collectionTemplate) {
      collectionTemplate.classList.remove('loading');
    }
    
    if (skeletonGrid) {
      skeletonGrid.style.display = 'none';
    }
    
    if (productsGrid) {
      productsGrid.style.display = 'grid';
    }
    
    if (collectionHeader) {
      collectionHeader.style.display = 'block';
    }
    
    if (comparisonContainer) {
      comparisonContainer.style.display = 'block';
    }
  }

  /**
   * Get metric grade and CSS class based on rating percentage
   */
  function getMetricGrade(rating) {
    if (rating >= 75) return { label: 'Best', class: 'progress-best' };
    if (rating >= 50) return { label: 'Better', class: 'progress-better' };
    return { label: 'Good', class: 'progress-good' };
  }

  /**
   * Animate progress bars within a container
   */
  function animateProgressBars(container = document) {
    const progressBars = container.querySelectorAll('.progress-bar');
    progressBars.forEach((bar, index) => {
      const width = bar.getAttribute('data-width');
      setTimeout(() => {
        bar.style.width = width + '%';
      }, index * 100);
    });
  }

  /**
   * Reset progress bars within a container
   */
  function resetProgressBars(container = document) {
    const progressBars = container.querySelectorAll('.progress-bar');
    progressBars.forEach(bar => {
      bar.style.width = '0%';
    });
  }
});